import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const roleHome = {
    superadmin: '/admin',
    admin:      '/admin',
    setter:     '/setter',
    editor: '/editor/questions',
    participant: '/participant'
};

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const successMsg = location.state?.message;

    const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const user = await login(form.email, form.password);
            nav(roleHome[user.role] || '/');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card card">
                <div className="auth-logo">Uni<span>Quiz</span></div>
                <h2 style={{ marginBottom: 20, fontSize: 20 }}>Kirish</h2>
                {successMsg && <div className="alert alert-success">{successMsg}</div>}
                {error && <div className="alert alert-error">{error}</div>}
                <form onSubmit={submit}>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" value={form.email} onChange={set('email')} required autoFocus />
                    </div>
                    <div className="form-group">
                        <label>Parol</label>
                        <input type="password" value={form.password} onChange={set('password')} required />
                    </div>
                    <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                        {loading ? <span className="spinner" /> : 'Kirish'}
                    </button>
                </form>
                <div className="auth-footer">
                    Hisobingiz yo‘qmi? <Link to="/register">Ro‘yxatdan o‘tish</Link>
                </div>
            </div>
        </div>
    );
}